export default "__VITE_ASSET__DPgUFhJ0__"